<template>
  <div>
    <div class="b-admin-partner" v-if="kyc_verification_type == 'ckyc'">
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'ku' }"
        :to="{ name: 'ckyc-details',  params: { status: 'CKycVerificationPending', partner: 'ku'  } }">
        Kuvera 
      </router-link>
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'az' }"
        :to="{ name: 'ckyc-details',  params: { status: 'CKycVerificationPending', partner: 'az'  } }">
        Amazon
      </router-link>  
    </div>
    <div class="b-admin-partner" v-else-if="kyc_verification_type == 'video'">
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'ku' }"
        :to="{ name: 'video-details',  params: { status: 'videoVerificationPending', partner: 'ku'  } }">
        Kuvera 
      </router-link>
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'az' }"
        :to="{ name: 'video-details',  params: { status: 'videoVerificationPending', partner: 'az'  } }">
        Amazon
      </router-link>  
    </div>
    <div class="b-admin-partner" v-else-if="kyc_verification_type == 'signature'">
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'ku' }"
        :to="{ name: 'verify-signature',  params: { status: 'signatureVerificationPending', partner: 'ku'  } }">
        Kuvera 
      </router-link>
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'az' }"
        :to="{ name: 'verify-signature',  params: { status: 'signatureVerificationPending', partner: 'az'  } }">
        Amazon
      </router-link>  
    </div>
    <div class="b-admin-partner" v-else>
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'ku' }"
        :to="{ name: 'kyc-details', params: { status: 'Pending', partner: 'ku'  } }">
        Kuvera 
      </router-link>
      <router-link 
        class="b-admin-partner-button"
          :class="{ 'b-admin-partner-button-highlight': admin_partner == 'az' }"
        :to="{ name: 'kyc-details', params: { status: 'Pending', partner: 'az'  }  }">
        Amazon
      </router-link>  
    </div>

    <router-view 
      :key="$route.fullPath">
    </router-view>
  </div>
</template>
<script>

import Vue from 'vue'
import { mapGetters } from 'vuex'
import FileSaver from 'file-saver'
import Moment from 'moment-mini'

export default {
  data() {
    return {
      loaded: false,
      super_admin: false,
    }
  },
  mounted() {

    // this.$store.commit('reset_admin_partner'); 
    if (this.$route.params.kyc_verification_type){
      this.$store.commit('set_kyc_verification_type', this.$route.params.kyc_verification_type || 'kyc')
    }

    // if (this.kyc_verification_type && this.admin_partner && !["ckyc-details", "kyc-details"].includes(this.$route.name)){
    //   console.log("in redirect")
    //   this.redirect()
    // }
       // this.$store.commit('set_admin_partner', this.$route.params.partner)
  },

  methods: {
    redirect(){
      if (this.kyc_verification_type == 'ckyc'){
        this.$router.replace({ name: 'ckyc-details',  params: { status: 'CKycVerificationPending', partner: this.admin_partner  } } )
      } else if (this.kyc_verification_type == 'video'){
        this.$router.replace({ name: 'video-details',  params: { status: 'videoVerificationPending', partner: this.admin_partner  } } )
      } else if (this.kyc_verification_type == 'signature') {
        this.$router.replace({ name: 'video-details',  params: { status: 'signatureVerificationPending', partner: this.admin_partner  } } )
      }
      else {
        this.$router.replace({ name: 'kyc-details',  params: { status: 'Pending', partner: this.admin_partner  } } )
      }
    }

  },

  computed: {
    ...mapGetters(['admin_partner','kyc_verification_type']),

  }
} 
</script>
<style scoped>
.row-highlight {
  background-color: #24cdc6;
}
.amc-option {
  width: 285px;
  margin: 1px;
  height:34px;
  font-size:15px;
}

.b-admin-partner{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 16px;
  justify-content: center;
}
.b-admin-partner-button {
  font-size: 1.5em !important;
  line-height: 1.5em !important;
  margin-top:10px;
  margin-right: 10px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  border-color: #03b9f5;  
  padding: 5px;
  text-decoration: none;
}
.b-admin-partner-button-highlight {
  background-color: #03b9f5;
  color: white;
}

input {
  margin: 15px auto;
  display: block;
  width: 50%;
  padding: 8px;
  border: 1px solid black;
}

.b-container-btn {
  text-align: center;
  cursor: pointer;
}
  
.b-margin{
  margin-right: 20px;
}
</style>
